<div class="flex flex-col gap-2">
  @if (navigationErrorMessageKey()) {
    <p class="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900">
      {{ navigationErrorMessageKey()! | translate }}
    </p>
  }
  @if (effectiveShowSaveAsDraft()) {
    <button
      type="button"
      class="flex min-h-[48px] w-full shrink-0 flex-row flex-nowrap items-center justify-center gap-2 rounded-full border-2 border-[#5a2f6b] bg-white px-4 py-3 text-center text-sm font-bold text-[#5a2f6b] shadow-sm active:scale-[0.99] disabled:pointer-events-none disabled:opacity-40"
      [disabled]="effectiveDraftDisabled()"
      (click)="emitSaveAsDraft()"
    >
      <span class="inline-flex min-h-0 min-w-0 max-w-full items-center justify-center gap-2">
        @if (isSaving()) {
          <span class="flex size-6 shrink-0 items-center justify-center" aria-hidden="true">
            <span class="material-icons animate-spin text-[20px] leading-none">progress_activity</span>
          </span>
        } @else {
          <span class="flex size-6 shrink-0 items-center justify-center" aria-hidden="true">
            <span class="material-icons text-[20px] leading-none">save</span>
          </span>
        }
        <span class="min-w-0 whitespace-normal leading-snug">{{ labelSaveAsDraft() | translate }}</span>
      </span>
    </button>
  }
  <div class="flex flex-wrap gap-2">
    <button
      type="button"
      class="min-h-[48px] flex-1 rounded-full border border-[#ece4f3] bg-white px-4 py-3 text-sm font-bold text-[#3d2652] shadow-sm active:scale-[0.99] disabled:opacity-40"
      [disabled]="effectivePreviousDisabled()"
      (click)="emitPrevious()"
    >
      {{ labelPrevious() | translate }}
    </button>
    @if (!effectiveIsLastStep()) {
      <button
        type="button"
        class="min-h-[48px] flex-[2] rounded-full bg-[#5a2f6b] px-4 py-3 text-sm font-bold text-white shadow-lg active:scale-[0.99] disabled:opacity-40"
        [disabled]="effectiveNextDisabled()"
        (click)="emitNext()"
      >
        {{ labelNext() | translate }}
      </button>
    } @else if (allowSubmit()) {
      <button
        type="button"
        class="flex min-h-[48px] min-w-0 flex-[2] flex-row flex-nowrap items-center justify-center gap-2 rounded-full bg-[#5a2f6b] px-4 py-3 text-center text-sm font-bold text-white shadow-lg active:scale-[0.99] disabled:opacity-40"
        [disabled]="effectiveSubmitDisabled()"
        (click)="emitSubmit()"
      >
        @if (isSaving()) {
          <span class="inline-flex min-h-0 min-w-0 max-w-full items-center justify-center gap-2">
            <span class="flex size-6 shrink-0 items-center justify-center" aria-hidden="true">
              <span class="material-icons animate-spin text-[18px] leading-none">progress_activity</span>
            </span>
            <span class="min-w-0 whitespace-normal leading-snug">{{ "mobile.eachat.wizard.saving" | translate }}</span>
          </span>
        } @else {
          <span class="min-w-0 whitespace-normal px-0.5 text-center leading-snug">{{ labelComplete() | translate }}</span>
        }
      </button>
    }
  </div>
</div>
